import '@gameday/app/lib/js/setPublicPath';
import { GamedayAppBase } from '@gameday/app';
import initClient from 'bdata-react-component';
import { DataEngine } from '@gameday/core';
import componentMap from './src/componentMap';
import siteConfig from './src/js/site-config-options';
import '@gameday/app/lib/styles/app.css';
import './src/styles/app.css';

import { dealWithAdobeMc } from '@gameday/tracking/lib/adobe-tracking';

class GamedayApp extends GamedayAppBase {
    constructor () {
        const baseConf = {
            ...siteConfig.game,
            config: siteConfig.config,
            mount: siteConfig.mount,
            tracking: siteConfig.tracking,
            ads: siteConfig.adConfig
        };
        super(baseConf);
        const moreOpts = {
            componentMap,
            DataEngine
        };
        dealWithAdobeMc();
        const _root = initClient(this.appContainer, { ...this.opts, ...moreOpts });
        this.init(_root);
    }
}

export const bootstrap = function () {
    const app = new GamedayApp({ ...siteConfig.game, config: siteConfig.config, mount: siteConfig.mount, tracking: siteConfig.tracking, ads: siteConfig.ads });
    app.prefetch().then(() => app.render(), () => app.render());
};

export default GamedayApp;
